import Image from "next/image";
import { RESPONSIVE_CAROUSEL } from "~/utils/constants";
import React, { type FC } from "react";
import AliceCarousel, { Link } from "react-alice-carousel";
import { type SubCategoryType } from "~/lib/db/multimedia";
import PrevButton from "./PrevButton";
import NextButton from "./NextButton";
type CarouselTermsLoopProps = {
  carouselTermsLoop: SubCategoryType[];
};

const CarouselTermsLoop: FC<CarouselTermsLoopProps> = ({
  carouselTermsLoop,
}) => {
  return (
    <AliceCarousel
      mouseTracking={true}
      responsive={RESPONSIVE_CAROUSEL}
      autoPlay={false}
      disableDotsControls={true}
      disableButtonsControls={false}
      renderPrevButton={() => {
        return carouselTermsLoop.length > 2 && <PrevButton color="#fff" />;
      }}
      renderNextButton={() => {
        return carouselTermsLoop.length > 2 && <NextButton color="#fff" />;
      }}
    >
      {carouselTermsLoop.map((term, index) => (
        <article
          key={term.slug}
          className="articleWrap carousel-cell flex w-full flex-col px-2"
        >
          <figure>
            <Link
              href={`/m/${term.slug}`}
              className={`flex w-full rounded-[50px] bg-lightLightGray transition-all ${
                carouselTermsLoop.length < 2 ? "md:max-w-[426px]" : ""
              }`}
            >
              {term.img != null && (
                <Image
                  src={term.img}
                  alt={term?.name || "immagine di copertina"}
                  className="aspect-4/3 h-full w-full rounded-[40px] object-cover mix-blend-multiply hover:opacity-80"
                  sizes="(min-width: 769px) 50vw, (min-width: 1024px) 25vw, (min-width: 1300px) 20vw, 100vw"
                  width={500}
                  height={400}
                  placeholder="blur"
                  blurDataURL={term.img}
                  priority={index < 3}
                />
              )}
            </Link>
          </figure>
        </article>
      ))}
    </AliceCarousel>
  );
};

export default CarouselTermsLoop;
